module.exports = __webpack_public_path__ + "img/edit.6767c6b1.svg";